import React from 'react';

const Progress = () => (
  <div className="progress">
    <div className="progress-img" />
    <div>
      <p className="percent">79%</p>
      <p className="completed">Ongoing</p>
    </div>
  </div>
);

export default Progress;
